import { alpha } from '@mui/material';
var DarkTheme = function (fontFamily) {
    return {
        // palette values for dark mode
        primary: {
            dark: '#AFBCFF',
            main: '#FFFFFF',
            light: '#002B62',
            lightSidebar: '#002B62',
            contrastText: '#0A0D14',
        },
        error: {
            dark: '#EA8387',
            main: '#EA8387',
            light: '#EA8387',
            contrastText: '#FFF',
        },
        secondary: {
            dark: '#1414A0',
            main: '#212529',
            light: alpha('#1D2433', 0.87),
            lightGray: '#E9ECEF',
            contrastText: '#fff',
        },
        overlay: {
            main: alpha('#212529', 0.4),
        },
        neutral: {
            100: '#F5F5F5',
            200: '#F0F0F0',
            300: '#D9D9D9',
            500: '#8C8C8C',
        },
        danger: {
            dark: '#1414A0',
            main: '#EA8387',
            light: '#EA8387',
            secondary: alpha('#1414A0', 0.5),
        },
        border: {
            container: '#404040',
            textField: alpha('#fff', 0.23),
        },
        text: {
            primary: alpha('#fff', 0.87),
            'on-primary': '#fff',
            main: '#FFFFFF',
            secondary: '#636674',
            disabled: alpha('#FFF', 0.6),
            tertiary: alpha('#0F131A', 0.6),
            info: '#0E663D',
            success: '#5AA2F3',
            warning: '#755003',
            danger: '#A8222F',
        },
        textIcon: {
            primary: alpha('#fff', 0.87),
        },
        background: {
            default: '#212529',
            paper: '#212529',
            dialog: '#212529',
            blue: {
                500: '#1414A0',
                100: '#E7F1FF',
            },
        },
        fontFamily: fontFamily,
        spacing: 8,
        blue: {
            500: '#1414A0',
        },
        red: {
            600: '#B02A37',
            100: '#F8D7DA',
        },
        green: {
            600: '#0E663D',
            100: '#D1E7DD',
        },
        grey: {
            900: '#1C2025',
            600: '#6C757D',
            200: '#495057',
        },
        common: {
            black: '#001631',
            white: '#D1E7DD',
        },
    };
};
export default DarkTheme;
